import React, { PureComponent, Component } from 'react';

class ArchivoValido extends Component {
    constructor(props) {
        super(props)
        this.selectRadio = this.selectRadio.bind(this);
    }


    selectRadio(value) {
        this.props.selectRadio("PermiteVacio", value)

    }

    render() {
        return (
            <div className="row top-separator-xs">
                <div className="form-group bottom-separator-xs" style={{ marginLeft: "15px" }}>
                    <div className="col-md-12 no-padding-left">
                        <label className="label-primary">
                            ¿Se considera válido un archivo sin registros?
                        </label>
                    </div>
                    <div>

                        <div className="row row-radio">
                            <div style={{ marginLeft: "4px" }} className="col-xs-12">
                                <div className="container-radio radio-margin">
                                    <input id={"rbArchivo" + 1}
                                        type="radio"
                                        name="rbArchivo"
                                        value={true}
                                        checked={this.props.proceso.PermiteVacio == true}
                                        onChange={(event) => this.selectRadio(true)} />

                                    <label
                                        className="lbl-radio label-secondary"
                                        htmlFor={"rbArchivo" + 1}>
                                        {"SÍ"}
                                    </label>
                                </div>
                            </div>
                        </div>

                        <div className="row row-radio">
                            <div style={{ marginLeft: "4px" }} className="col-xs-12">
                                <div className="container-radio radio-margin">
                                    <input id={"rbArchivo" + 2}
                                        type="radio"
                                        name="rbArchivo"
                                        value={false}
                                        checked={this.props.proceso.PermiteVacio == false}
                                        onChange={(event) => this.selectRadio(false)} />

                                    <label
                                        className="lbl-radio label-secondary"
                                        htmlFor={"rbArchivo" + 2}>
                                        {"NO"}
                                    </label>
                                </div>
                            </div>
                        </div>
                    </div>
                </div>
            </div>
        )
    }
};

export default ArchivoValido;